import Reveal from "@/components/site/Reveal";
import ExpandableCard from "@/components/site/ExpandableCard";
import { openLead, bookHour } from "@/lib/site";

const SERVICES = [
  {
    id: "servizio-unora-con-luciano",
    name: "Un'ora con Luciano",
    price: "80€",
    tagline: "Un dubbio preciso? Un'ora, a prezzo fisso, senza impegno.",
    details: [
      "Porti una domanda concreta: prezzi, annuncio, un property manager da valutare",
      "Un'ora di videochiamata, solo noi due",
      "Esci con risposte chiare e una direzione, non con un preventivo da firmare",
      "Se poi serve altro, sai già cosa chiedere e a chi",
    ],
    owner: "Luciano",
  },
  {
    id: "servizio-vengo-a-vederti",
    name: "Vengo a vederti",
    price: "Gratis con un percorso",
    tagline: "Il sopralluogo di persona: la tua struttura vista coi miei occhi, non da una dashboard.",
    details: [
      "Visita di persona alla tua struttura, in tutta la Sicilia",
      "Criticità e opportunità: quello che foto e numeri da soli non raccontano",
      "Come lavori oggi: cosa del tuo modo di gestire impatta le recensioni",
      "Report scritto con le priorità, in parole semplici",
      "Gratis se poi attivi un percorso: il primo passo non è mai un rischio",
    ],
  },
  {
    id: "servizio-analisi-apertura",
    name: "Analisi di apertura",
    price: "100€",
    tagline: "Stai per aprire? Parti coi numeri giusti.",
    details: [
      "Guardo la tua zona: quanta gente cerca, quando, a che prezzo",
      "Quanto puoi guadagnare davvero, senza illusioni",
      "Il prezzo giusto per partire e cosa fare nei primi 90 giorni",
      "Tutto scritto in un report, più mezz'ora di call per spiegartelo",
    ],
    owner: "Luciano",
  },
  {
    id: "servizio-strategia-prezzi",
    name: "Strategia prezzi",
    price: "300€",
    tagline: "I tuoi prezzi, costruiti sui numeri della tua zona — non a sentimento.",
    details: [
      "Analisi del mercato: chi cerca casa nella tua zona, quando, a che prezzo",
      "Analisi dei competitor: quanto chiedono e come lavorano le strutture simili alla tua",
      "Analisi delle vendite nella tua zona: cosa si è venduto davvero, non cosa è rimasto invenduto",
      "I numeri vengono da AirDNA, lo strumento professionale dei revenue manager — non da un'occhiata in giro",
      "La tua strategia completa: prezzo base, stagioni, last minute, soggiorni lunghi",
    ],
    owner: "Luciano",
  },
  {
    id: "servizio-creare-annuncio",
    name: "Creare l'annuncio",
    price: "450€",
    tagline: "Il tuo annuncio, scritto e impostato da chi lo fa tutti i giorni.",
    details: [
      "Titolo e descrizione scritti per convincere chi legge",
      "Le foto giuste, nell'ordine giusto",
      "Impostazioni corrette su Booking e Airbnb dal primo giorno",
      "Prezzi e calendario pronti da pubblicare",
    ],
    owner: "Luciano — con Giovanni per le foto",
  },
  {
    id: "servizio-foto-annuncio",
    name: "Foto che vendono",
    price: "da 400€",
    tagline: "Lo shooting di Giovanni più il rifacimento dell'annuncio: il prima e il dopo si vede nei click.",
    details: [
      "Shooting fotografico della struttura con Giovanni, il nostro fotografo",
      "Le foto giuste, nell'ordine giusto: cosa mostrare prima e cosa togliere",
      "Titolo e descrizione rifatti attorno alle nuove foto",
      "Prezzo finale in base alla struttura: lo confermiamo prima, niente sorprese",
    ],
    owner: "Giovanni — con Luciano per l'annuncio",
  },
  {
    id: "servizio-checkup-ota",
    name: "Check-up del tuo annuncio",
    price: "100€",
    tagline: "Un controllo completo del tuo annuncio, spiegato in parole semplici.",
    details: [
      "Prezzi e calendario: dove perdi prenotazioni o soldi",
      "Le promozioni attive: quali ti servono e quali ti fanno solo perdere margine",
      "Come sei messo rispetto ai concorrenti della tua zona, su dati professionali AirDNA — non a sentimento",
      "Un report chiaro: cosa sistemare subito, in ordine di importanza",
    ],
    owner: "Luciano",
  },
];

export default function Services() {
  return (
    <section id="servizi" data-testid="services-section" className="scroll-mt-20 border-b border-[#2A241F] py-12 sm:py-28 lg:py-36">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <Reveal>
          <p className="section-kicker">Servizi</p>
          <h2 className="mt-4 font-heading text-3xl font-black uppercase leading-[1.05] tracking-tight text-[#FAF7F2] sm:text-4xl lg:text-5xl">
            Prezzi chiari, scritti qui
          </h2>
        </Reveal>

        <div className="mt-8 space-y-2 sm:mt-14 sm:space-y-4">
          {SERVICES.map((s, i) => (
            <Reveal key={s.id} delay={i * 0.07}>
              <ExpandableCard
                {...s}
                group="servizi"
                index={i + 1}
                ctaLabel="Inizia da qui"
                ctaTestId={`cta-${s.id}`}
                onCta={() => (s.id === "servizio-unora-con-luciano" ? bookHour() : openLead(s.name))}
              />
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.2}>
          <div data-testid="services-credit-note" className="mt-6 border border-[#4D2C20] bg-[#2B1B15] p-5 sm:mt-10 sm:p-8">
            <p className="section-kicker">Niente si paga due volte</p>
            <p className="mt-3 text-base font-light leading-relaxed text-[#FAF7F2] sm:hidden">
              Se poi entri nella Gestione continua, quanto hai già pagato per questi servizi ti viene scalato.
            </p>
            <p className="mt-3 hidden max-w-2xl text-base font-light leading-relaxed text-[#FAF7F2] sm:block sm:text-lg">
              Se parti da uno di questi servizi e poi entri nella <span className="font-medium">Gestione continua</span>, il costo dei servizi già fatti ti viene scalato. Il primo passo non è mai un rischio.
            </p>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
